import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '../common/vuex/store'
import VueResource from 'vue-resource'
import VueRaven from 'vue-raven'
import { APP_CONFIG } from './const/config.const'
import { APP_ENV } from '@/common/const/env.const'
import { TOPUP_CONFIG } from './const/topup.const'
import filterPln from '../common/filters/pln.filter'
import requiredMarkDirective from '../common/directives/required-mark'
import { BmPrivacyVue } from '@bm/privacy'

Vue.config.productionTip = false
Vue.use(VueResource)
Vue.use(BmPrivacyVue.default, { locale: 'pl', env: process.env.NODE_ENV })

Vue.directive('required-mark', requiredMarkDirective)
Vue.filter('pln', filterPln)

Vue.prototype.$VUE_APP_OPERATOR = APP_CONFIG.OPERATOR
Vue.prototype.$VUE_APP_CONFIG = APP_CONFIG[process.env.NODE_ENV]
Vue.prototype.$VUE_TOPUP_CONFIG = TOPUP_CONFIG

if (process.env.NODE_ENV === APP_ENV.production) {
  Vue.use(VueRaven, {
    dsn: APP_CONFIG[process.env.NODE_ENV].SENTRY,
    environment: process.env.NODE_ENV
  })
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
